export enum TabsList {
  CurrentUsers = 'currentUsers',
  PendingUsers = 'pendingUsers',
  DisabledUsers = 'disabledUsers',
  SharedUsers = 'sharedUsers',
}

export enum GroupTabsList {
  Local = 'Local',
  Federated = 'Federated',
  Shared = 'Shared',
  System = 'System',
}

export enum DefaultValue {
  All_groups = 'All_groups',
}

export type GroupTypeOptions = GroupTabsList | DefaultValue;
